export default "__VITE_ASSET__9SH5kohz__"